module.exports = __webpack_public_path__ + "img/menu_33.7c219260.png";